module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_3009.c10df0fb.png";